export default __webpack_public_path__ + "static/media/lastframe-md-1x.cc4de696.jpg";